import createClient from "openapi-fetch"
import type { paths, components } from "./api-schema"

const client = createClient<paths>({ baseUrl: "/api" })

export type State = components["schemas"]["State"]
export type Vote = components["schemas"]["Vote"]
export type User = components["schemas"]["User"]

export default class API {
	static async getState(year?: number): Promise<State> {
		const data = (await client.GET("/state", {})).data
		if (year != undefined && data.year != year) {
			return { year, voting: false, ongoing: false }
		} else return data
	}

	static setState = async (year: number, voting: boolean, ongoing: boolean, token: string): Promise<State> =>
		(await client.PUT("/state", {
			params: { header: { token } },
			body: { year, voting, ongoing }
		})).data

	static getVotes = async (year: number, user?: string, country?: string): Promise<Vote[]> =>
		(await client.GET("/votes/{year}", { params: { path: { year } } })).data

	static setVote = async (year: number, user: string, country: string, score: number): Promise<Vote> =>
		await (await client.PUT("/votes/{year}/{user}/{country}", {
			params: { path: { year, user, country } },
			body: score
		})).data

	static getUsers = async (name?: string): Promise<string[]> =>
		(await client.GET("/users", {})).data

	static addUser = async (name: string): Promise<User> =>
		(await client.POST("/users/{name}", { params: { path: { name } } })).data

	static checkToken = async (token: string): Promise<boolean> =>
		(await client.GET("/token", { params: { header: { token } } })).response.ok

	static addToken = async (tokenToAdd: string, token: string): Promise<boolean> =>
		(await client.POST("/token", {
			params: { header: { token } },
			body: tokenToAdd
		})).response.ok

	static deleteToken = async (tokenToDelete: string, token: string): Promise<boolean> =>
		(await client.DELETE("/token", {
			params: { header: { token } },
			body: tokenToDelete
		})).response.ok

}
